import config from 'react-global-configuration';
import { referenceLoadingStart, referenceLoadingDone } from '../../UI/ReferenceLoading';
import { setOperationStatus, UI_OPERATION_STATUS_ERROR, UI_OPERATION_STATUS_REQUEST, UI_OPERATION_STATUS_SUCCESS } from '../../UI';
export var userGet = function userGet(userId) {
  var viewMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  return function (dispatch, getState) {
    dispatch(referenceLoadingStart());
    var API_URL = config.get('API_URL');
    var language = getState().getIn(['ui', 'language']);
    var MULTILINGUAL = config.get('MULTILINGUAL', true);
    var PATH = MULTILINGUAL ? "".concat(API_URL, "/").concat(language) : API_URL;
    var credentials = getState().getIn(['ui', 'fetch', 'credentials', 'user']) || getState().getIn(['ui', 'fetch', 'credentials', 'content'], 'include');
    var headers = getState().getIn(['ui', 'fetch', 'headers', 'content']);
    fetch("".concat(PATH, "/user/").concat(userId, "?_format=json&viewMode=").concat(viewMode), {
      credentials: credentials,
      headers: headers
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      dispatch(userGetLoaded(userId, response));
      dispatch(referenceLoadingDone());
    }).catch(function () {
      dispatch(referenceLoadingDone());
    });
  };
};
export var userUpdate = function userUpdate(userId, values) {
  var API_URL = config.get('API_URL');
  var csrfToken;
  return function (dispatch) {
    dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_REQUEST));
    fetch("".concat(API_URL, "/session/token"), {
      credentials: 'include'
    }).then(function (response) {
      return response.text();
    }).then(function (response) {
      csrfToken = response;
      fetch("".concat(API_URL, "/user/").concat(userId), {
        method: 'PATCH',
        credentials: 'include',
        body: JSON.stringify(values),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        }
      }).then(function (response) {
        if (response.ok) return response.json();else throw new Error();
      }).then(function (response) {
        dispatch(userGetLoaded(userId, response));
        dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_SUCCESS));
      }).catch(function () {
        dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_ERROR));
      });
    }).catch(function () {});
  };
};
export var USER_GET_LOADED = 'USER_GET_LOADED';
export function userGetLoaded(userId, data) {
  return {
    type: USER_GET_LOADED,
    user_id: userId,
    data: data
  };
}